import energy_1 from './energy.png';
import communication_1 from './communication.png';
import illumination_1 from './illumination.png';
import traffic_1 from './traffic.png';
import transportation_1 from './transportation.png';
import parking_1 from './parking.png';
import solid_waste_1 from './solid_waste.png';
import water_1 from './water.png';
import default_1 from './default.png';
import emergency_1 from './emergency.png';
import environment_1 from './environment.png';


export {
    default_1,
    energy_1,
    parking_1,
    solid_waste_1,
    water_1,
    communication_1,
    illumination_1,
    traffic_1,
    transportation_1,
    emergency_1,
    environment_1
};